import { createIcon } from '@chakra-ui/icon';
import * as React from 'react';
export var CloseIcon = createIcon({
  displayName: 'CloseIcon',
  viewBox: '0 0 24 24',
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 6.5C10.7958 10.7958 17.5 17.5 17.5 17.5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 6.5C13.2042 10.7958 6.5 17.5 6.5 17.5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "2"
  }))
});
//# sourceMappingURL=Close.js.map